import { useQuery } from '@tanstack/react-query';
import { useTranslate } from '@tolgee/react';
import { Select } from 'antd';
import { useMemo } from 'react';
import { queries } from 'services/queries';

interface Props {
  departments?: Dashboard.Department[];
  value?: number[];
  onChange?: (value: number[]) => void;
}
export const QaPairSubmitterSelect = (props: Props) => {
  const { departments, value, onChange } = props;
  const { t } = useTranslate();

  const { data: users, isLoading: loading } = useQuery({
    ...queries.departments.users(departments?.map((each) => `${each.id}`)),
  });

  const options = useMemo(() => {
    return users?.map((each) => {
      return {
        label: each.account,
        value: each.userId,
      };
    });
  }, [users]);

  return (
    <Select
      style={{ minWidth: '150px' }}
      loading={loading}
      options={options}
      placeholder={t('选择提交人')}
      maxTagCount={2}
      showArrow
      allowClear
      optionFilterProp="filterKey"
      dropdownMatchSelectWidth={false}
      mode="multiple"
      value={value}
      onChange={onChange}
    />
  );
};
